import React from "react";
import moment from "moment";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { getLectureHeading } from "Pages/MyScheduleBeta/LectureDetails/LectureTypes";

interface LectureTopBarProps {
  lecture: any;
  activeTab: string;
  onBack: () => void;
}

const LectureTopBar: React.FC<LectureTopBarProps> = ({
  lecture,
  activeTab,
  onBack,
}) => {
  const isDetailsTab = activeTab?.toLowerCase() === "details";
  const heading = getLectureHeading(lecture);

  return (
    <>
      <div
        className="mobile-header"
        style={{
          backgroundColor: "#ffffff",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <ArrowLeftOutlined
          onClick={onBack}
          style={{
            fontSize: "18px",
            color: "#111827",
            cursor: "pointer",
            padding: "4px",
            flexShrink: 0,
          }}
        />

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "16px",
              fontWeight: 700,
              color: "#111827",
            }}
          >
            {heading}
          </h1>
          {lecture?.startTime && lecture?.endTime && (
            <div
              style={{
                fontSize: "12px",
                color: "#1f2937",
                fontWeight: 450,
                display: "flex",
                alignItems: "center",
              }}
            >
              {moment(lecture.startTime).format("h:mm a")} –{" "}
              {moment(lecture.endTime).format("h:mm a")}
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          backgroundColor: "var(--primary-text)",
          padding: "12px 16px",
          textAlign: "center",
          color: "#ffffff",
          height: "120px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!isDetailsTab ? (
          <h2
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: 700,
              color: "#ffffff",
            }}
          >
            {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
          </h2>
        ) : (
          <div>
            <div
              style={{
                fontSize: "25px",
                fontWeight: 700,
              }}
            >
              {heading}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "4px",
                marginTop: "4px",
              }}
            >
              {lecture?.batchTimeTableId && (
                <div
                  style={{
                    border: "1px solid #ffffff",
                    borderRadius: "5px",
                    padding: "1px 6px",
                    fontSize: "11px",
                  }}
                >
                  Lecture ID : {lecture?.batchTimeTableId}
                </div>
              )}

              {lecture?.batchName && (
                <div
                  style={{
                    border: "1px solid #ffffff",
                    borderRadius: "5px",
                    padding: "1px 6px",
                    fontSize: "11px",
                  }}
                >
                  Batch Name : {lecture?.batchName}
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "attendance" && (
          <div style={{ fontSize: "11px", opacity: 0.85, marginTop: "4px" }}>
            Last updated by {lecture?.updatedByEmail} · {lecture?.updatedAt}
          </div>
        )}
      </div>
    </>
  );
};

export default LectureTopBar;
